import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Divider from '@material-ui/core/Divider';
import CloseIcon from "@material-ui/icons/Close";
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader/index';
import "../../../../_metronic/_assets/plugins/flaticon2/flaticon.css";
import { BsFileText } from "react-icons/bs";
import { AiFillFileText } from "react-icons/ai";

const useStyles = makeStyles({
  list: {
    width: 400,
    height: "100vh"
  },
  card: {
    margin: "30px"
  },
  pointer: {
    cursor: 'pointer'
  }
});

export default function View(props) {
  const { onClose, notification } = props;
  const {
    headerAz,
    headerEn,
    headerRu,

    textAz,
    textRu,
    textEn,


  } = notification;
  const classes = useStyles();
  const sideList = side => (
    <div
      className={classes.list}
      role="presentation"
    >
      <div className="col-12 d-flex align-items-center justify-content-between py-4">
        <h1 className="h3 mb-0">Notification details</h1>
        <CloseIcon className={classes.pointer} onClick={onClose} />
      </div>
      <Divider className="bg-dark" />
      <div className="drawer-body">
        <Card className={classes.card}>
          <CardHeader
            title="General information"
            className="bg-secondary text-dark h6 p-3"
            disableTypography
          />
          <CardHeader
            avatar={<BsFileText className="icon-primary" />}
            title={headerAz}
            subheader="Header Az"
            className="p-3"
          />
          <CardHeader
            avatar={<BsFileText className="icon-primary" />}
            title={headerEn}
            subheader="Header En"
            className="p-3"
          />
          <CardHeader
            avatar={<BsFileText className="icon-primary" />}
            title={headerRu}
            subheader="Header Ru"
            className="p-3"
          />
          <CardHeader
            avatar={<AiFillFileText className="icon-primary" />}
            title={textAz}
            subheader="Text Az"
            className="p-3"
          />

          <CardHeader
            avatar={<AiFillFileText className="icon-primary" />}
            title={textEn}
            subheader="Text En"
            className="p-3"
          />

          <CardHeader
            avatar={<AiFillFileText className="icon-primary" />}
            title={textRu}
            subheader="Text Ru"
            className="p-3"
          />

        </Card>
      </div>
    </div>
  );

  return (
    <Drawer {...props} anchor="right" className="drawer--fixed">
      {sideList('right')}
    </Drawer>
  );
}
